var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 6,
    viewBox: "0 0 15 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2724 2.53757L11.914 0.156069C11.7059 -0.0520231 11.3822 -0.0520231 11.1741 0.156069C10.966 0.364162 10.966 0.687861 11.1741 0.895954L12.6539 2.39884H2.17991L3.65968 0.895954C3.86777 0.687861 3.86777 0.364162 3.65968 0.156069C3.45159 -0.0520231 3.12789 -0.0520231 2.9198 0.156069L0.584536 2.53757C0.376444 2.74566 0.376444 3.06936 0.584536 3.27746L2.94292 5.65896C3.0354 5.75145 3.17413 5.82081 3.31286 5.82081C3.45159 5.82081 3.5672 5.77457 3.6828 5.68208C3.89089 5.47399 3.89089 5.15029 3.6828 4.9422L2.20303 3.43931H12.6539L11.1741 4.9422C10.966 5.15029 10.966 5.47399 11.1741 5.68208C11.2666 5.77457 11.4053 5.82081 11.5441 5.82081C11.6828 5.82081 11.8215 5.77457 11.914 5.65896L14.2724 3.27746C14.4805 3.06936 14.4805 2.74566 14.2724 2.53757Z",
    fill: "#996B68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.d4cf91fc2f418b8f045492461f09dfe5.svg";
export { ForwardRef as ReactComponent };